import React from 'react';
import classnames from 'classnames';
import { translate } from 'react-i18next';
import UserActions from 'users/components/UserActions';
import { formatDate } from 'react-day-picker/moment';

const UserRow = ({
  companyId,
  handleToggle = () => {},
  isLoading = false,
  permissions,
  t,
  user,
}) => (
  <tr>
    <td>{user.name}</td>
    <td>{user.lastname}</td>
    <td>{user.email}</td>
    <td>{formatDate(user.createdAt)}</td>
    <td
      className={classnames('text-center', {
        'table-success': user.company.active,
        'table-warning': !user.company.active,
      })}
    >
      {user.company.active ? t('common.yes') : t('common.no')}
    </td>
    <td className="text-center">{user.company.role.name}</td>
    <td className="text-center">
      <UserActions
        companyId={companyId}
        canToggle={permissions['acl.users.toggle'] || false}
        canUpdate={permissions['acl.users.update'] || false}
        handleToggle={handleToggle}
        isActive={user.company.active}
        isLoading={isLoading}
        id={user.id}
        isRoot={user.root}
        t={t}
      />
    </td>
  </tr>
);

export default translate()(UserRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/users/components/UserRow.js